export default "__VITE_ASSET__BVl$Sa1c__"